<template>
  <div class="progress-area">
    <div class="progress-point" v-for="(item, index) in stages" @click="changeCurrent(index)" :class="{ 'selected' : selectValue <= current && selectValue=== index, 'active' : current >= index}">
      <div class="point-text">{{item}}</div>
      <img src="../assets/appointment/icon-arrow.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'appointment-progress',
  props: ['stages', 'current', 'selectValue'],
  data () {
    return {};
  },
  methods: {
    changeCurrent (index = '') {
      this.$emit('changeCurrent', index);
    }
  }
}
</script>
<style lang="scss">
  .progress-area{
    height: 1.34rem;
    padding: 0 0.34rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: start;
    align-items: center;
    text-align: center;
    font-size: 0.3rem;
    color: #4f2400;
    .progress-point{
      display: flex;
      align-items: center;
      &.active{
        color: white;
        .point-text{
          background-color: #4f2400;
        }
      }
      .point-text{
        width: 0.9rem;
        height: 0.56rem;
        line-height: 0.56rem;
        background-color: #f7f6f2;
        border-radius: 0.06rem;
      }
      img{
        width: 0.34rem;
        height: 0.1rem;
        margin: 0 0.13rem;
      }
    }
    .progress-point:last-child img{
      display: none;
    }
  }
</style>
